"use client"

import { useTranslations } from "@/lib/intl/use-translations"

interface Props {
  privacyHref: string
  /** Translation namespace holding `privacyText` + `privacyLink`. Defaults to "ui". */
  namespace?: string
  className?: string
}

/**
 * Shared privacy-policy notice — single source of the
 * "{privacyText} <a>{privacyLink}</a>." markup used by the waitlist email
 * step and the quiz email step.
 */
export function PrivacyNotice({
  privacyHref,
  namespace = "ui",
  className,
}: Props) {
  const t = useTranslations(namespace as Parameters<typeof useTranslations>[0])
  return (
    <p className={className ?? "type-body-sm text-center text-neutral-400"}>
      {t("privacyText")}{" "}
      <a
        href={privacyHref}
        target="_blank"
        rel="noopener noreferrer"
        className="underline underline-offset-2"
      >
        {t("privacyLink")}
      </a>
      .
    </p>
  )
}
